import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";

const Bank = (props: SvgProps) => (
  <Svg width={33} height={32} fill="none" {...props}>
    <Path
      fill="#000"
      stroke="#000"
      strokeWidth={0.6}
      d="M1.5 29.75h30V31h-30v-1.25Zm30-19.315v1.817h-3.75V24.75h2.5V26H2.75v-1.25h2.5v-12.5H1.5v-1.816c0-1.431.795-2.716 2.074-3.355l11.395-5.692a3.215 3.215 0 0 1 3.081.01l11.376 5.68a3.732 3.732 0 0 1 2.074 3.357ZM6.5 24.75h5v-12.5h-5v12.5Zm13.75-12.5h-7.5v12.5h7.5v-12.5Zm6.25 0h-5v12.5h5v-12.5Zm3.75-1.816c0-.954-.53-1.811-1.383-2.238l-11.396-5.69a1.987 1.987 0 0 0-1.924-.01l-11.415 5.7a2.484 2.484 0 0 0-1.382 2.238v.567h27.5v-.567Z"
    />
  </Svg>
);
export default Bank;
